import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateResponsibleModel,
  SearchResponsibleModel,
} from '../../../models/responsible.model'
@Injectable({
  providedIn: 'root',
})
export class ResponsibleService {
  private baseUrl = environment.baseUrl
  private resource: string = 'Responsavel'

  constructor(private httpClient: HttpClient) {}

  public createResponsible(
    model: any,
    // model: CreateResponsibleModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/create`, model)
  }

  public editResponsible(
    model: any,
    // model: EditResponsibleModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/edit`, model)
  }

  public deleteResponsible(
    model: any,
    // model: DeleteResponsibleModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/delete`, model)
  }

  public listPagedResponsible(page: number, rows: number = 15): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  listPagedResponsibleByPerson(idPerson: number, page: number, rows: number = 15, orderBy: string = ''): Observable<ResponseRequestModel> {
    if (idPerson === 0) throw Error
    if (orderBy.length > 0) {
      orderBy = 'orderBy=' + orderBy
    }
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/pessoa/${idPerson}?pageNumber=${page}&pageSize=${rows}&${orderBy}`,
    )
  }
  searchPagedResponsibleByPerson(
    idPerson: number,
    page: number,
    rows: number = 15,
    model?: any,
    orderBy = '',
  ): Observable<ResponseRequestModel> {
    if (idPerson === 0) throw Error

    let params = new HttpParams().set('pageNumber', String(page)).set('pageSize', String(rows))

    Object.entries(model).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, String(value))
      }
    })

    if (orderBy?.length > 0) {
      params = params.set('orderBy', orderBy)
    }
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/pessoa/${idPerson}`,
      {
        params,
      },
    )
  }
  public listResponsible(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/listall`)
  }

  listResponsibleByPerson(idPerson: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/listall/pessoa/${idPerson}`)
  }

  public searchResponsible(model: SearchResponsibleModel): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/search`, model)
  }

  public getResponsiblebyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/${id}`)
  }

  public searchPagedResponsible(
    page: number,
    rows: number = 15,
    model: SearchResponsibleModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
